/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React from 'react';

import { OuiI18nNumber } from '../../../../src/components';

export default () => {
  return (
    <p>
      Formatted count of users: <OuiI18nNumber value={5000000} />
    </p>
  );
};
